import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlashIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0388 14.8198H20.4787C22.1587 14.8198 22.4987 13.9098 21.2387 12.7998L12.6388 5.22982C11.5888 4.29982 10.7188 4.68982 10.7188 6.09982V7.02983",
			stroke: "white",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.84087 9.18L3.52087 9.18C1.84087 9.18 1.50087 10.09 2.76087 11.2L11.3609 18.77C12.4109 19.7 13.2809 19.31 13.2809 17.9V14.81L14.4609 14.81",
			stroke: "white",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 2L22 22",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFlashIcon;
